import styled from "styled-components";
import { shade } from "polished";

interface EnvironmentButtonProps {
  active: boolean;
}

const Container = styled.div`
  
`;

const EnvironmentButton = styled.button<EnvironmentButtonProps>`
  cursor: pointer;
  border-radius: 10px;
  color: #ffffff;
  font-size: 12px;
  border: none;
  padding: 12px 4px;
  width: 100%;
  transition: 0.5s;

  &:disabled {
    cursor: default;
  }

  &:hover:enabled {
    background-color: ${({ theme }) => shade(0.2, theme.colors.disabled)};
  }

  background-color: ${({ active, theme }) => (active ? theme.colors.primary : theme.colors.disabled)};
`;

export { Container, EnvironmentButton };
